import api from '../api';

/**
 * @param {string} apdataParams
 * @returns {Promise<Object>} personalData
 * @returns {string} personalData.nomeCompleto
 * @returns {string} personalData.dddTelefone
 * @returns {string} personalData.telefone
 * @returns {string} personalData.dddWhatsapp
 * @returns {string} personalData.whatsapp
 * @returns {string} personalData.email
 * @returns {string} personalData.cidade
 * @returns {string} personalData.estado
 * @returns {string} personalData.dataNascimento
 * @returns {number} personalData.folha
 * @returns {string} personalData.cpf
 */
const searchPersonalData = async (apdataParams, originCoop) => {
  const url = `/api/login/${apdataParams}`;
  return api.get(url, { originCoop });
};

export default searchPersonalData;
